import React from 'react';
import { Box } from '@mui/material';
import { ActiviteWidget, ActiviteWidgetType } from '../../molecules';

export type ActiviteListProps = {
    items?: Array<ActiviteWidgetType>;
};

export const ActiviteList: React.FunctionComponent<ActiviteListProps> = function (
    props: ActiviteListProps,
) {
    const { items } = props;
    return (
        <Box>
            {items
                ? items.map((itemProps: ActiviteWidgetType, index) => (
                      <ActiviteWidget
                          key={`activite-${itemProps.activite.domaine}}`}
                          {...itemProps}
                          index={index}
                      />
                  ))
                : null}
        </Box>
    );
};
